import * as React from 'react';
import * as PartnerCheckoutStore from '../../store/PartnerCheckout';

type OrderConfirmationProps = {
    partnerCheckoutState: PartnerCheckoutStore.IState;
}

const OrderConfirmation: React.FC<OrderConfirmationProps> = ({
    partnerCheckoutState,
}) => {

    const errorOnSubmitOrder = !partnerCheckoutState.customerOrderNumber
        && partnerCheckoutState.hasErrorOnSubmit;

    return (
        <React.Fragment>
            <div className="row mb-4">
                <div className="col">
                    {partnerCheckoutState.customerOrderNumber
                    || (!errorOnSubmitOrder && !partnerCheckoutState.cartProductsChanged)
                    &&
                        <div className="section-title order-success-message my-4">
                            <div dangerouslySetInnerHTML={{ __html: "OrderResponse: <strong>" + partnerCheckoutState.customerOrderNumber + "</strong>" }}>
                            </div>
                        </div>
                    }
                    {
                        errorOnSubmitOrder
                            && !partnerCheckoutState.cartProductsChanged
                            && <div className="section-title order-error-message">
                            <div dangerouslySetInnerHTML={{ __html: "There was an issue processing your order. Please try again later." }}>
                            </div>
                        </div>
                    }
                    {
                        !partnerCheckoutState.customerOrderNumber
                            && partnerCheckoutState.cartProductsChanged
                            && < div className="section-title order-error-message">
                            <div dangerouslySetInnerHTML={{ __html: "One or more products in your cart have been updated. Please review your cart." }}>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </React.Fragment>
    );
}
export default OrderConfirmation;